import React, { useState, useEffect } from 'react';
import MarketoForm from '../../../../../views/components/MarketoForm/MarketoForm';
import { Section } from '../../../../fc-components/main/components';

const NewsletterPageMarketo = () => {
  const [checkedCompass, setCheckCompass] = useState(true);
  const [checkedCodesign, setCheckCodesign] = useState(true);
  const [checkedImpact, setCheckImpact] = useState(true);
  const [checkedPlugged, setCheckPlugged] = useState(true);

  const handleCheckCompass = () => {
    setCheckCompass(!checkedCompass);
    if (checkedCompass) {
      document.getElementsByName('optInFCCompassNewsletter')[0].checked = false;
    } else {
      document.getElementsByName('optInFCCompassNewsletter')[0].checked = true;
    }
  };

  const handleCheckCodesign = () => {
    setCheckCodesign(!checkedCodesign);
    if (checkedCodesign) {
      document.getElementsByName(
        'optInFCCoDesignNewsletter'
      )[0].checked = false;
    } else {
      document.getElementsByName('optInFCCoDesignNewsletter')[0].checked = true;
    }
  };

  const handleCheckImpact = () => {
    setCheckImpact(!checkedImpact);
    if (checkedImpact) {
      document.getElementsByName('optInFCImpactNewsletter')[0].checked = false;
    } else {
      document.getElementsByName('optInFCImpactNewsletter')[0].checked = true;
    }
  };

  const handleCheckPlugged = () => {
    setCheckPlugged(!checkedPlugged);
    if (checkedPlugged) {
      document.getElementsByName('optInFCTechNewsletter')[0].checked = false;
    } else {
      document.getElementsByName('optInFCTechNewsletter')[0].checked = true;
    }
  };

  useEffect(() => {
    document.body.classList.add('newsletters');
  });

  return (
    <div>
      <Section name="newsletters__page__header" noPadding bgColor="#F58473">
        <h1> Explore Fast Company Newsletters </h1>
        <h2>
          {' '}
          Discover new perspectives. Sign up to get our most important coverage
          delivered to your inbox.{' '}
        </h2>
        <img
          src="https://wp-cms-fastcompany-com.s3.amazonaws.com/uploads/2022/12/shutterstock_1901181142-Converted_v2.png"
          alt=""
        />
      </Section>
      <Section bgColor="#F4F4F4" noPadding>
        <div className="newsletters__page__marketo">
          <div className="newsletters__page__marketo__form__container">
            <div className="options">
              <section>
                <div className="timeFrame">
                  <p> Daily </p>
                  <input
                    type="checkbox"
                    checked={checkedCompass}
                    onChange={handleCheckCompass}
                  />
                </div>
                <img
                  src="https://assets.fastcompany.com/image/upload/v1670274719/fc-newsletter-logo.svg"
                  alt=""
                />
                <p className="description">
                  Fast Company’s trending stories delivered to you daily
                </p>
              </section>
              <section>
                <div className="timeFrame">
                  <p> Weekdays </p>
                  <input
                    type="checkbox"
                    checked={checkedCodesign}
                    onChange={handleCheckCodesign}
                  />
                </div>
                <img
                  src="https://assets.fastcompany.com/image/upload/v1670274604/fc-newsletter-logo_CoDesign.svg"
                  alt=""
                />
                <p className="description">
                  The latest innovations in design brought to you every weekday
                </p>
              </section>
              <section>
                <div className="timeFrame">
                  <p> Weekly </p>
                  <input
                    type="checkbox"
                    checked={checkedImpact}
                    onChange={handleCheckImpact}
                  />
                </div>
                <img
                  src="https://assets.fastcompany.com/image/upload/v1670274672/fc-newsletter-logo_impact.svg"
                  alt=""
                />
                <p className="description">
                  A weekly look at the people and ideas making an impact in
                  society and business
                </p>
              </section>
              <section>
                <div className="timeFrame">
                  <p> Weekly </p>
                  <input
                    type="checkbox"
                    checked={checkedPlugged}
                    onChange={handleCheckPlugged}
                  />
                </div>
                <img
                  src="https://assets.fastcompany.com/image/upload/v1670274702/fc-newsletter-logo_pluggedin.svg"
                  alt=""
                />
                <p className="description">
                  Tech insights, news, and trends from Global Technology Editor
                  Harry McCracken
                </p>
              </section>
            </div>
            <MarketoForm assetId={1018} />
          </div>
        </div>
      </Section>
      <Section name="newsletters__page__footer" noPadding>
        <div className="support">
          <h3> Need Help? </h3>
          <h4>
            {' '}
            Contact{' '}
            <a href="malito:newsletters@fastcompany.com" target="_top">
              {' '}
              newsletters@fastcompany.com{' '}
            </a>{' '}
          </h4>
          <h4>
            {' '}
            Visit the{' '}
            <a
              href="https://register.fastcompany.com/fc-preference-center.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              {' '}
              Preference Center{' '}
            </a>{' '}
            to manage your account{' '}
          </h4>
        </div>
        <div className="subscribe">
          <h3> Subscribe </h3>
          <h4>
            {' '}
            Unparalleled Journalism.{' '}
            <a
              href="https://www.fastcompany.com/subscribe"
              target="_blank"
              rel="noopener noreferrer"
            >
              {' '}
              Subscribe{' '}
            </a>{' '}
            to Fast Company Premium{' '}
          </h4>
        </div>
      </Section>
    </div>
  );
};

export default NewsletterPageMarketo;
